<template>
  <div>
    <common-table :table-columns="tableColumns"
                  :url="url" :operate="operate"
                  :form-fields="formFields"
                  :permission="permission"
                  :buttons="buttons"
                  :searchs="searchs"
                  @returnId="returnId"
                  @vieoUpdate="vieoUpdate"
                  ref="table"></common-table>

    <div class="dialog">
      <el-dialog title="播放视频"
                 :visible.sync="showVideoVisible"
                 custom-class="common-dialog"
                 :close-on-click-modal="false"
                 width="30%">
        <video class="product_video" :loop="true" controls :autoplay="true" :src="videoSrc"></video>
        <div slot="footer" class="dialog-footer">
          <!-- <el-button size="small" @click="showVideoVisible = false">取 消</el-button> -->
          <el-button type="primary" size="small" @click="showVideoVisible = false">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import request from "@/utils/axios";
import message from "@/utils/message";

export default {
  name: "AiKLingVideo",
  components: {CommonTable},
  data() {
    return {
      form: {
        startCreateTime: '',
        endCreateTime: '',
        cookiesNameList: '',
        agentId: '',
        status: ''
      },
      showVideoVisible: false,
      videoSrc: '',
      selectIds: [],
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: []
      }, {
        name: 'douyinReleaseId',
        placeholder: '自动选品ID',
        type: 'input'
      }],
      permission: {
        add: 'aiKLingVideo:add',
        update: 'aiKLingVideo:update',
        delete: 'aiKLingVideo:delete',
        deleteBatch: 'aiKLingVideo:deleteBatch'
      },
      url: {
        get: '/aiKLingVideo/listByCondition',
        add: '/aiKLingVideo/add',
        update: '/aiKLingVideo/update',
        delete: '/aiKLingVideo/delete/',
        delete_batch: '/aiKLingVideo/deleteBatch',
        status: '/aiKLingVideo/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      },
        {
          field: 'agentId',
          label: '代理',
          selectUrl: '/agent/getAll',
          selectData: [],
          show: {
            type: 'select',
          },
        }, {
          field: 'douyinReleaseId',
          label: '自动选品ID',
          detail: true,
          show: true,
        }, {
          field: 'taskId',
          label: '任务Id',
          detail: true,
          show: true,
        }, {
          field: 'aiVideoMsg',
          label: 'Ai生成日志',
          detail: true,
          show: false,
        }, {
          field: 'aiVideoStatus',
          label: 'AI生成状态',
          show: {
            type: 'tag',
            tags: [{
              key: 0,
              value: '未提交',
              type: 'info'
            }, {
              key: 1,
              value: '已提交',
              type: 'primary'
            }, {
              key: 2,
              value: '已完成',
              type: 'success'
            }, {
              key: 3,
              value: '生成失败',
              type: 'danger'
            }, {
              key: 4,
              value: '排队中',
              type: 'primary'
            }]
          },
          detail: false,
        }, {
          field: 'path',
          label: '视频地址',
          detail: true,
          show: false,
        }],
      operate: [
        {
          icon: 'el-icon-video-camera',
          type: 'text',
          text: '播放存储mp4_url',
          playVideo: true,
          handle: (row) => {
            console.log(row.path, '123123')
            if (row.path) {
              this.showVideoVisible = true
              this.videoSrc = row.path
            }
          },
        },   {
          icon: 'el-icon-magic-stick',
          type: 'text',
          text: '更新AI生成状态',
          handle: (row) => {
            console.log(row, '111');
            const douyinReleaseId = row.douyinReleaseId;
            const newData = {
              id: douyinReleaseId
            };
            request.post({
              url: '/douYinRelease/updateVideoStatus',
              data: newData,
              success: (res) => {
                console.log(res);
                if (res.code === 0) {
                  message.success("更新状态成功");
                  this.$refs.table.getData();
                } else {
                  message.error(res.msg);
                }
              }
            });
          }
        }
      ],
      buttons: [],
      formFields: {
        addTitle: '抖音预发布管理添加',
        updateTitle: '抖音预发布管理修改',
        model: [],
      }
    }
  },
  methods: {
    returnId(data) {
      this.selectIds = data;
      console.log(this.selectIds)
    },
    vieoUpdate(data) {
      this.operate[0].value = data
      this.$refs.table.getData()
    }
  }
}
</script>

<style scoped>
.product_video {
  width: 80%;
  margin-left: 10%;
}

.dialog_body_aiCreate {
  padding: 50px;
}

.totalImgBox {
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
}

.radioBox {
  padding-bottom: 50px;
  width: 30%;
  /* padding-right: 80px; */
}

/deep/ .el-radio__inner {
  width: 20px !important;
  height: 20px !important;
}

.input_ai {
  width: 300px !important;
  margin-right: 50px;
}

.coverImg {
  padding: 20px;
}

.coverImg_text {
  font-size: 22px;
  color: #000;
  padding-bottom: 10px;
}

.coverImg img {
  height: 200px;
  width: 200px;
}

.coverBox {
  padding: 20px 0 5px 15px;
  font-size: 30px;
}

.coverTextBox {
  width: 200px;
}
</style>